module.exports = __webpack_public_path__ + "img/103.2.283b3a25.png";